import { render, staticRenderFns } from "./OrgMemberProjectAccess.vue?vue&type=template&id=d6d87e28&scoped=true&"
import script from "./OrgMemberProjectAccess.vue?vue&type=script&lang=js&"
export * from "./OrgMemberProjectAccess.vue?vue&type=script&lang=js&"
import style0 from "./OrgMemberProjectAccess.vue?vue&type=style&index=0&id=d6d87e28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d87e28",
  null
  
)

export default component.exports